import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import { makeStyles } from "@material-ui/core/styles";
import * as XLSX from "xlsx";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function PedidosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  const URL_PAQUETERIAS = process.env.REACT_APP_URL_PAQUETERIAS;
  const AREAS_MELI = process.env.REACT_APP_AREAS_MELI_1_FULL;
  const AREAS_MELI_NOVA = process.env.REACT_APP_AREAS_MELI_2_FULL;
  const AREAS_AMAZON = process.env.REACT_APP_AREAS_AMAZON_1_FBA;
  const AREAS_AMAZON_YOU = process.env.REACT_APP_AREAS_AMAZON_2_FBA;
  const URL_VARIANTES = process.env.REACT_APP_URL_VARIANTES_ARTICULOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [value, setValue] = useState("");
  const [departamentoCliente, setDepartamentoCliente] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inventarios, setInventarios] = useState([]);

  const [cliente, setCliente] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState([]);
  const [paqueteria, setPaqueteria] = useState("");
  const [sucursal, setSucursal] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);

  const [paqueterias, setPaqueterias] = useState([]);
  const [selectedPaqueteria, setSelectedPaqueteria] = useState("665e148c225a1c1e3f506999");

  const [listaPrecios, setListaPrecios] = useState(1);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      articulosNombre: "",
      piezasPorCaja: 0,
      cajas: 0,
      cantidad: 0,
      precio: 0,
      precioBruto: 0,
      total: 0,
      disponible: 0,
      cliente:"NA",
      variante: "",
      variantesOptions: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [cargando, setCargando] = useState(false);

  const Toast = Swal.mixin({
      toast: true,
      position: "center",
      showConfirmButton: false,
      // timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
    if (cargando) {
      Toast.fire({
        // html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
        html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
        title: "Cargando Disponibles....",
        customClass: {
          icon: 'animated-icon'
        }
      });
    }

  useEffect(() => {
  // Carga inicial de datos que no dependen de selectedArea
  const token = localStorage.getItem("app_token");

  const fetchAll = async () => {
    try {
      const [clientes, paqueterias, colaboradores, areas] = await Promise.all([
        axios.get(`${URL_CLIENTES}General`, { headers: { Authorization: `Bearer: ${token}` } }),
        axios.get(URL_PAQUETERIAS, { headers: { Authorization: `Bearer: ${token}` } }),
        axios.get(URL_COLABORADORES, { headers: { Authorization: `Bearer: ${token}` } }),
        axios.get(URL_AREAS, { headers: { Authorization: `Bearer: ${token}` } }),
      ]);

      setClientes(clientes.data);
      setPaqueterias(paqueterias.data);
      setColaboradores(colaboradores.data);
      setAreas(areas.data);
    } catch (err) {
      console.error("Error cargando datos iniciales:", err);
    }
  };

  fetchAll();
}, []);

useEffect(() => {
  if (cargando) {
    const Toast = Swal.mixin({
      toast: true,
      position: "center",
      showConfirmButton: false,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });

    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Cargando Disponibles....",
    });
  } else {
    Swal.close();
  }
}, [cargando]);

useEffect(() => {
  const token = localStorage.getItem("app_token");

  if (selectedArea) {
    setCargando(true); // Esto activa el Swal por el otro useEffect

    axios
      .get(`${URL_INVENTARIOS}DisponibleAlmacen/${selectedArea}`, {
        headers: { Authorization: `Bearer: ${token}` },
      })
      .then((res) => {
        setInventarios(res.data);
      })
      .catch((err) => {
        console.error("Error cargando inventarios:", err);
        Swal.fire("Error", "No se pudo cargar inventarios", "error");
      })
      .finally(() => {
        setCargando(false); // Esto apaga el Swal
      });
  } else {
    setInventarios([]); // Limpia inventario si no hay área
  }
}, [selectedArea]);


  const savePedido = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    let totalPedido = inputFields.length;

    try {
      await axios
        .post(
          URL_PEDIDOS,
          {
            fecha,
            clientes: value._id,
            departamentosClientes: departamentoCliente,
            colaboradores: selectedColaborador,
            total_general: parseFloat(total_general).toFixed(2),
            observaciones,
            total_cantidad,
            paqueterias: selectedPaqueteria,
            areas: selectedArea,
            sucursales: sucursal,
            comisionTDC,
            comisionFlete,
            subTotal: parseFloat(subTotal).toFixed(2),
            iva: parseFloat(iva).toFixed(2),
            impuestos: selectedImpuesto,
            surtido: "No",
            autorizadoApartado: "Si",
            autorizadoSurtido: "Si",
            editado: "No",
            fechaModificado:fecha,
            creado: user.id,
            fecha_estimada: fecha,
            fecha_entrega: fecha,
            entregaInsumos:"No"
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          inputFields.map((a) => {
            if (a.articulos != "" && a.cantidad != 0) {
              axios
                .post(
                  URL_ARTICULOS_PEDIDO,
                  {
                    pedidos: data.data._id,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    cantidadProcesos: 0,
                    surtido: 0,
                    pendiente_surtir: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio).toFixed(2),
                    precioBruto: parseFloat(a.precioBruto).toFixed(2),
                    total: parseFloat(a.total).toFixed(2),
                    autorizadoApartado: "Si",
                    autorizadoSurtido: "Si",
                    cliente: a.cliente,
                    variante: a.variante || null,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalPedido = totalPedido - 1;
                  if (totalPedido == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Pedido",
                          detalle: `${value._id} ${total_general}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", `success`);
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      });
                  }
                });
            } else {
              totalPedido = totalPedido - 1;
              if (totalPedido == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Pedido",
                      detalle: `${value._id} ${total_general}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  });
              }
            }
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        precioBruto: 0,
        total: 0,
        disponible: 0,
        cliente: "NA",
        variante: "",
        variantesOptions: [],
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * TG) / 100 +
        TG +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecioBruto = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.precioBruto = value;
        // let totalParcial = i.cantidad * i.precio;
        // i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cantidad = event.target.value;
        i.cajas = (parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)).toFixed(2);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
      inventarios.map((a) => {
        if (a.idArticulo == selectedArticulo.idArticulo) {
          let idArticulo = a.idArticulo;
          let piezasPorCaja = a.piezasPorCaja;
          let precio;
          if (listaPrecios == 1) {
            precio = a.lista1;
          } else if (listaPrecios == 2) {
            precio = a.lista2;
          } else if (listaPrecios == 3) {
            precio = a.lista3;
          } else if (listaPrecios == 4) {
            precio = a.lista4;
          }
          let precioBruto;
          if (listaPrecios == 1) {
            precioBruto = a.lista1Bruto;
          } else if (listaPrecios == 2) {
            precioBruto = a.lista2Bruto;
          } else if (listaPrecios == 3) {
            precioBruto = a.lista3Bruto;
          } else if (listaPrecios == 4) {
            precioBruto = a.lista4Bruto;
          }
          let articulosNombre = [a.MLM || a.SKU, a.nombre].filter(Boolean).join(" ");
          let disponible = a.disponible;
          // Load variantes for this article
          const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
          axios.get(`${URL_VARIANTES}/articulo/${idArticulo}`, auth)
            .then(res => {
              handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio, precioBruto, articulosNombre, disponible, res.data);
            })
            .catch(() => {
              handleChangeInputArticulo(id, idArticulo, piezasPorCaja, precio, precioBruto, articulosNombre, disponible, []);
            });
        }
      });
  }

  const handleChangeInputArticulo = (id, idArticulo, piezasPorCaja, precio, precioBruto, articulosNombre, disponible, variantesOptions = []) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.piezasPorCaja = piezasPorCaja;
        i.precioBruto = precioBruto;
        i.precio = precio;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.articulosNombre = articulosNombre;
        i.disponible = disponible;
        i.variante = "";
        i.variantesOptions = variantesOptions;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * TG) / 100 +
        TG +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  }

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  const options2 = inventarios.map((option) => {
    const junta = (option.MLM || option.SKU) + " " + option.nombre + " " + option.variante;
    const firstLetter = option.SKU[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function jalaCliente(selectedCliente) {
    setValue(selectedCliente);

    axios
      .get(`${URL_CLIENTES}/${selectedCliente._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCliente = res.data;

        setCliente(allCliente);
        setSelectedColaborador(allCliente.vendedor[0]._id);
        setDepartamentoCliente(allCliente.departamentosClientes[0]._id)
        setListaPrecios(allCliente.listaPrecios);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_SUCURSALES}/clientes/${selectedCliente._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSucursales = res.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaSucursal(value) {
    let split = value.split(",");
    let dir = split[0];

    setSelectedSucursal(value);
    setSucursal(dir);
  }

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e != 0) {
      setIva((e * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );
  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * subTotal) / 100 +
        subTotal +
        parseFloat(e) +
        parseFloat(comisionFlete)
    );
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    setTotalGeneral(
      (selectedImpuesto * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(e)
    );
  }

  function autorizaCambio() {
    if (password == PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }
  function importarArchivo(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Crear un objeto que mapee los SKU de los artículos a sus objetos correspondientes
        const articulosMap = {};
        inventarios.forEach((articulo) => {
          articulosMap[articulo.SKU] = articulo;
        });

        const articulosNoEncontrados = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {
          const articulo = articulosMap[a.SKU];
          if (articulo) {
            inputFields.push({
              id: uuidv4(),
              articulos: articulo.idArticulo,
              articulosNombre: articulo.MLM + " " + articulo.nombre,
              piezasPorCaja: 0,
              cajas: 0,
              cantidad: a.Unidades,
              precio: parseFloat((a.Precio / a.Unidades).toFixed(2)),
              precioBruto: a.PrecioBruto,
              total: a.Precio,
              disponible: 0,
              cliente: a.Comprador || "NA",
            });
          } else {
            // Si no se encuentra el artículo, agregarlo a la lista de no encontrados
              articulosNoEncontrados.push(a.SKU);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes SKU no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        ActualizaTotales();
      };
    }
  }
  const sec = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "14px 16px", marginBottom: 16 };

  return (
    <>
      <Header />
      <br /><br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 className="text-center mt-3 mb-3">Nuevo Pedido</h3>

          {/* 📋 Encabezado */}
          <div style={block}>
            <div style={sec}>📋 Encabezado</div>
            <Row>
              <Col md={2}>
                <FormGroup>
                  <Label>Fecha</Label>
                  <Input type="date" value={fecha} required onChange={e => setFecha(e.target.value)} />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Cliente</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => jalaCliente(selectedCliente)}
                    options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                    renderOption={(option) => (
                      <React.Fragment>{option.codigo} {option.nombre_comercial}</React.Fragment>
                    )}
                  />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Vendedor</Label>
                  <Input type="select" value={selectedColaborador} disabled>
                    <option value="">Selecciona un Vendedor</option>
                    {colaboradores.sort((a, b) => a.nombre > b.nombre ? 1 : -1).map(a => (
                      <option key={a._id} value={a._id}>{a.nombre} {a.apellido}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Sucursal</Label>
                  <Input type="select" value={selectedSucursal} onChange={e => jalaSucursal(e.target.value)}>
                    <option value="">Selecciona una Sucursal</option>
                    {sucursales.sort((a, b) => a.alias > b.alias ? 1 : -1).map(a => {
                      if (a.is_active == "Si") return <option key={a._id} value={[a._id]}>{a.alias}</option>;
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Paquetería</Label>
                  <Input type="select" value={selectedPaqueteria} required onChange={e => setSelectedPaqueteria(e.target.value)}>
                    <option value="0">Selecciona</option>
                    {paqueterias.sort((a, b) => a.name > b.name ? 1 : -1).map(a => (
                      <option key={a._id} value={a._id}>{a.name}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <FormGroup>
                  <Label>Almacén a Surtir</Label>
                  <Input type="select" value={selectedArea} onChange={e => {
                    setSelectedArea(e.target.value);
                    setCargando(true);
                    setInventarios([]);
                    setInputFields([{ id: uuidv4(), articulos: "", articulosNombre: "", piezasPorCaja: 0, cajas: 0, cantidad: 0, precio: 0, precioBruto: 0, total: 0, disponible: 0, cliente: "NA", variante: "", variantesOptions: [] }]);
                  }}>
                    <option value="">Selecciona un almacén</option>
                    {areas.sort((a, b) => a.name > b.name ? 1 : -1)
                      .filter(a => ![AREAS_AMAZON, AREAS_AMAZON_YOU, AREAS_MELI, AREAS_MELI_NOVA].includes(a._id))
                      .map(a => <option key={a._id} value={a._id}>{a.name}</option>)}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Observaciones</Label>
                  <Input type="text" value={observaciones} required onChange={e => setObservaciones(e.target.value)} />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Importar desde Excel</Label>
                  <Input type="file" name="file" id="file" disabled={inventarios.length === 0} onChange={e => importarArchivo(e)} />
                </FormGroup>
              </Col>
            </Row>
          </div>

          {/* 💰 Totales */}
          <div style={block}>
            <div style={{ ...sec, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>💰 Totales</span>
              <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "2px 14px", fontSize: "0.85rem", fontWeight: 700 }}>
                {new Intl.NumberFormat("en-US").format(total_cantidad)} pzas · {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(total_general)}
              </span>
            </div>
            <Row>
              <Col md={1}>
                <FormGroup>
                  <Label>Impuestos %</Label>
                  <Input type="number" min="0" step="any" value={selectedImpuesto} onChange={e => calculaImpuesto(e.target.value)} />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Sub Total</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={subTotal} disabled className="form-control" />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>IVA</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={iva} disabled className="form-control" />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label>Total</Label>
                  <CurrencyInput intlConfig={{ locale: "en-US", currency: "USD" }} prefix="$" defaultValue={0} decimalsLimit={2} value={total_general} disabled className="form-control" />
                </FormGroup>
              </Col>
              <Col md={1}>
                <FormGroup>
                  <Label>Piezas</Label>
                  <Input type="number" min="0" step="any" value={total_cantidad} disabled />
                </FormGroup>
              </Col>
            </Row>
          </div>

          {/* 📦 Artículos */}
          <div style={block}>
            <div style={{ ...sec, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>📦 Artículos</span>
            </div>
            <div className="table-responsive">
              <table className="table table-sm table-bordered table-striped">
                <thead className="thead-light">
                  <tr>
                    <th style={{ minWidth: 220 }}>Artículo</th>
                    <th style={{ minWidth: 130 }}>Variante</th>
                    <th style={{ width: 90, textAlign: "center" }}>Disponible</th>
                    <th style={{ width: 100 }}>Cliente</th>
                    <th style={{ width: 70, textAlign: "center" }}>Pzs/Caja</th>
                    <th style={{ width: 85 }}>Cantidad</th>
                    <th style={{ width: 90 }}>Precio</th>
                    <th style={{ width: 90 }}>P. Bruto</th>
                    <th style={{ width: 95, textAlign: "right" }}>Total</th>
                    <th style={{ width: 70 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {inputFields.map((inputField) => (
                    <tr key={inputField.id}>
                      <td>
                        <Autocomplete
                          size="small"
                          value={inputField.articulosNombre}
                          onChange={(event, selectedArticulo) => BuscaArticulo(inputField.id, selectedArticulo)}
                          options={options2.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                          groupBy={(option) => option.firstLetter}
                          getOptionLabel={(option) => typeof option === "string" ? option : option.junta}
                          renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                          renderOption={(option) => (
                            <React.Fragment>{option.MLM || option.SKU} {option.nombre}</React.Fragment>
                          )}
                        />
                      </td>
                      <td className="align-middle">
                        {inputField.variantesOptions && inputField.variantesOptions.length > 0 ? (
                          <Input type="select" bsSize="sm" value={inputField.variante}
                            onChange={e => setInputFields(inputFields.map(i => i.id === inputField.id ? { ...i, variante: e.target.value } : i))}>
                            <option value="">Sin variante</option>
                            {inputField.variantesOptions.map(v => <option key={v._id} value={v._id}>{v.nombre}</option>)}
                          </Input>
                        ) : <span style={{ color: "#94a3b8", fontSize: "0.8rem" }}>—</span>}
                      </td>
                      <td className="align-middle text-center">
                        <span style={{ fontWeight: 600, color: inputField.disponible > 0 ? "#16a34a" : "#dc2626" }}>
                          {new Intl.NumberFormat("en-US").format(inputField.disponible)}
                        </span>
                      </td>
                      <td>
                        <Input bsSize="sm" name="cliente" type="text" value={inputField.cliente} onChange={e => handleChangeInput(inputField.id, e)} />
                      </td>
                      <td className="align-middle text-center">
                        <Input bsSize="sm" name="piezasPorCaja" type="number" min="0" step="any" value={inputField.piezasPorCaja} disabled />
                      </td>
                      <td>
                        <Input bsSize="sm" name="cantidad" type="number" min="0" step="any" placeholder="Cant." value={inputField.cantidad} required onChange={e => handleChangeInputCantidad(inputField.id, e)} />
                      </td>
                      <td>
                        <Input bsSize="sm" name="precio" type="number" min="0" step="any" value={inputField.precio} disabled={!user.cambiaPrecios && !cambiarPrecio} onChange={e => handleChangeInput(inputField.id, e)} />
                      </td>
                      <td>
                        <Input bsSize="sm" name="precioBruto" type="number" min="0" step="any" value={inputField.precioBruto} onChange={e => handleChangeInput(inputField.id, e)} />
                      </td>
                      <td className="align-middle text-right">
                        <strong style={{ color: "#1e3a8a" }}>
                          {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(inputField.total)}
                        </strong>
                      </td>
                      <td className="align-middle text-center">
                        <Button size="sm" color="danger" disabled={inputFields.length === 1} onClick={() => handleRemoveFields(inputField.id)} tabIndex="-1">
                          <i className="fas fa-minus" />
                        </Button>{" "}
                        <Button size="sm" color="success" onClick={handleAddFields} tabIndex="-1">
                          <i className="fas fa-plus" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-3 mb-4">
            {validaBoton ? (
              <Button color="success" onClick={savePedido}>
                <i className="fas fa-save" style={{ marginRight: 6 }} />Guardar Pedido
              </Button>
            ) : (
              <Button color="success" disabled>
                <Spinner size="sm" style={{ marginRight: 6 }} />Guardando...
              </Button>
            )}{" "}
            <Button color="danger" href="/ListadoPedidos">
              <i className="fas fa-arrow-left" style={{ marginRight: 6 }} />Regresar
            </Button>
          </div>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}><h4>Progreso</h4></ModalHeader>
            <ModalBody>
              <h4>Este proceso puede tardar varios segundos.<br />Por favor no cierre ni refresque su navegador.</h4>
              <br />
              <div className="progreso">
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
                <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
              </div>
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalCambiaPrecio} toggle={toggleCambiaPrecio}>
            <ModalHeader toggle={toggleCambiaPrecio}><h4>Autorizar Cambio de Precio</h4></ModalHeader>
            <ModalBody>
              <Input type="password" placeholder="Password" value={password} required onChange={e => setPassword(e.target.value)} />
              <br />
              <Button color="success" onClick={autorizaCambio}>Autorizar</Button>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default PedidosCreate;
